import { Injectable, isDevMode } from '@angular/core';
import { SocketsLibService, ReactiveSocket } from 'sockets-lib';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { map } from 'rxjs/internal/operators/map';
import { BoDaoService } from 'src/app/dao/bo-dao-service/bo-dao.service';
import { SocketChannel } from 'src/app/models/communication-models/socket-channel.model';
import { MultimediaManagerDialogUploaderService } from 'src/app/modules/multimedia-manager/multimedia-manager-dialog-uploader/multimedia-manager-dialog-uploader.service';
import { environment } from 'src/environments/environment';
import { NotificationsService } from '../notifications-services/notifications.service';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  nSocket: ReactiveSocket;

  constructor(private socketsService: SocketsLibService,
              private userStorageService: UserStorageService,
              private boDaoService: BoDaoService,
              private multimediaManagerDialogUploaderService: MultimediaManagerDialogUploaderService,
              private notificationService: NotificationsService) { }

  public listenCommunications(socketChannel: SocketChannel) {
    this.nSocket = this.connect((environment.communication.https ? 'https://' : 'http://') + socketChannel.Url, socketChannel.Channel, { path: socketChannel.Path, secure: true, rejectUnauthorized: false });
    this.nSocket.onConnect().subscribe(
      (connected: ReactiveSocket) => {
        isDevMode() ? console.dir(connected) : null;
        connected.emit('update', this.userStorageService.getContext());
        connected.listen('fileUploadFinished').subscribe(
          (fileUploadFinished) => {
            console.dir(fileUploadFinished);
            isDevMode() ? console.dir(fileUploadFinished) : null;
            this.multimediaManagerDialogUploaderService.finished(fileUploadFinished);
          }
        );
        connected.listen('fileProcessFinished').subscribe(
          (fileProcessFinished) => {
            console.dir(fileProcessFinished);
            isDevMode() ? console.dir(fileProcessFinished) : null;
            // this.notificationService.getLastNotifications();
            this.notificationService.notificateReportFinished();
          }
        );
    });
  }

  public getSocketChannels() {
    return this.boDaoService.getSocketChannels(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
      map(res => res['data'])
    );
  }

  private connect(url, channel, opts): ReactiveSocket {
    return this.socketsService.connect(url, channel, opts);
  }
}
